module.exports = __webpack_public_path__ + "assets/img/solution1.bdb50444.png";